const moment = require("moment");
import { IKeyValueLog } from "motw_core/Entity/IKeyValueLog";
import * as React from "react";
import { Emotions } from "source/app/domain/Emotions/Emotions";
import { DisplayKVBlock } from "source/app/presentation/MainPanel/KeyValueLogs/DisplayKVLogs/DisplayKVBlock/DisplayKVBlock";
import { maxItemsToDisplay } from "source/app/presentation/MainPanel/KeyValueLogs/KeyValueLogs";

export function DisplayKVLogs({
    kvLogs,
    GetColor,
}: {
    kvLogs: IKeyValueLog[];
    GetColor: (kvl: IKeyValueLog) => string;
}) {
    const preparedKVLogs = kvLogs
        // A legacy or malformed record should not take down the entire log row.
        // The row remains clickable, so its newest record can still be removed.
        .filter((kvl) =>
            Emotions.All.some((emotion) => emotion.character === kvl.value)
        )
        .filter((kvl, index) => index < maxItemsToDisplay)
        .reverse();

    return (
        <span>
            {preparedKVLogs.map((kvl, index) => {
                // 0th element doesn't render opacity properly so removing it
                if (index === 0) {
                    return null;
                }

                const color = GetColor(kvl);
                const currEmotion = Emotions.GetFromCharacter(kvl.value);

                const isFirstBlockOfDay =
                    index > 0
                        ? IsFirstBlockOfDay(
                              preparedKVLogs[index],
                              preparedKVLogs[index - 1]
                          )
                        : false;

                return (
                    <DisplayKVBlock
                        color={color}
                        key={index}
                        numItems={preparedKVLogs.length}
                        index={index}
                        isLowerBlock={!currEmotion.IsHigherThan(Emotions.Flow)}
                        isSpecialBlock={currEmotion.IsHigherThan(
                            Emotions.HighFlow
                        )}
                        isFirstBlockOfDay={isFirstBlockOfDay}
                        topOffsetIndex={currEmotion.Index - Emotions.Flow.Index}
                        keyValueLog={kvl}
                    />
                );
            })}
        </span>
    );
}

function IsFirstBlockOfDay(currBlock: IKeyValueLog, prevBlock: IKeyValueLog) {
    const currBlockDay = moment(currBlock.lastmodifiedtime).local().dayOfYear();
    const prevBlockDay = moment(prevBlock.lastmodifiedtime).local().dayOfYear();
    return currBlockDay !== prevBlockDay;
}
